import React from 'react';

function Services() {
  const services = [
    {
      id: 1,
      icon: 'bi-shield-check',
      title: 'Secure Patient Portal',
      description: 'Access your medical records anytime in a safe and secure environment. Your health information is protected with advanced security standards.'
      // description: 'Access your medical records securely anytime. Your health data is protected with industry-standard encryption.'
    },
    {
      id: 2,
      icon: 'bi-search',
      title: 'Smart Doctor Search',
      description: 'Quickly find the right doctor near you. Filter by specialty, location, and availability for instant booking.'
      // description: 'Find the right healthcare professional near you. Filter by specialty, location, and availability to book instantly.'
    },
    {
      id: 3,
      icon: 'bi-camera-video',
      title: 'Telemedicine Suite',
      description: 'Consult with doctors through secure video or voice calls and receive medical advice from the comfort of your home.'
      // description: 'Connect with doctors through high-quality video or voice calls. Get expert medical advice from your home.'
    },
    {
      id: 4,
      icon: 'bi-file-medical',
      title: 'Digital Prescriptions',
      description: 'Receive prescriptions instantly and manage them digitally. Access your medications anytime with ease.'
      // description: 'Receive and manage prescriptions digitally. We automatically route them to your preferred pharmacy.'
    },
    {
      id: 5,
      icon: 'bi-calendar-check',
      title: 'Doctor Calendar',
      description: 'Doctors can manage their schedules, set availability, and handle appointments efficiently in one place.'
      // description: 'Doctors can efficiently manage their schedules, set routine times, and handle appointments seamlessly.'
    },
    {
      id: 6,
      icon: 'bi-graph-up',
      title: 'Health Analytics',
      description: 'Track your health history with detailed insights. Monitor appointments, prescriptions, and records over time.'
      // description: 'Track your health journey with detailed analytics. Monitor appointments and records over time.'
    }
  ];

  return (
    <section className="section-padding bg-white" id="services">
      <div className="container-lg">
        <h6 className="text-center text-primary-custom fw-semibold mb-2">OUR SERVICES</h6>
        {/* <h2 className="section-title">Healthcare at Your Fingertips</h2> */}
        <h2 className="section-title">Fast, Simple & Reliable Healthcare</h2>
        {/* <p className="section-subtitle">
          Experience modern healthcare with FastInQueue. We connect patients with doctors through innovative digital solutions.
        </p> */}
        <p className="section-subtitle">
          Access trusted doctors, book appointments instantly, and manage your healthcare journey with FastInQueue's smart digital platform.
        </p>

        <div className="row g-4 mt-2">
          {services.map(service => (
            <div className="col-lg-4 col-md-6" key={service.id}>
              <div className="service-card shadow-sm hover-shadow">
                <div className="service-icon">
                  <i className={`bi ${service.icon}`}></i>
                </div>
                <h4>{service.title}</h4>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
